import React, { createContext, useContext, useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db2 } from './firebase/config';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const loginWithToken = async (token) => {
    try {
      const userRef = doc(db2, 'users', token);
      const userSnap = await getDoc(userRef);
      
      if (userSnap.exists()) {
        localStorage.setItem('userToken', token);
        setCurrentUser(userSnap.data());
        return true;
      }
      return false;
    } catch (error) {
      console.error("Login error:", error);
      return false;
    }
  };

  const logout = () => {
    localStorage.removeItem('userToken');
    setCurrentUser(null);
  };

  useEffect(() => {
    const token = localStorage.getItem('userToken');
    if (token) {
      loginWithToken(token).finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const value = {
    currentUser,
    loginWithToken,
    logout,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
